export default "__VITE_ASSET__DpjqkTFA__"